import React, { useState, useMemo, useRef, useEffect } from 'react';
import { Card, Justify, PagingQuery, SelectOption, Layout } from 'tea-component';
import CommonFilter from '@intelligence/components/CommonFilter';
import type { ICommonFilterInstance } from '@intelligence/components/CommonFilter';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import SearchRecent from '@/pages/intelligence/components/SearchRecent';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import usePCConsoleGamesModel from '@/pages/intelligence/pages/TopCharts/PCConsoleGames/hooks/usePCConsoleGamesModel';
import {
  TableSelectStatusType,
  TableSelectionType,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import TableContent from '@/pages/intelligence/pages/TopCharts/PCGames/components/Tables/MetricsTableTable';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import ChartIconType from '@/pages/intelligence/components/ChartsComponents/ChartIconType';
import MetricsTableVisualis from '@/pages/intelligence/pages/TopCharts/PCGames/components/Visualis/MetricsTableVisualis';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { dbiBtnLogMes, dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { dbiTopChartsBtnLogMes } from '@/pages/intelligence/utils/topChartsBuriedPointCfg';
import useInitFilterHook from '@intelligence/hooks/useInitFilterHook';
import {
  getDataSourcesMetricsByTopChartsType,
  getURLSearchParams,
  mapOptionValue2Text,
  isEmpty,
} from '@/pages/intelligence/utils/commonUtils';
import { cloneDeep, isEqual, merge } from 'lodash-es';
import { SteamSalesList } from '@/pages/intelligence/utils/echartsConst';
import { getFilterName } from '@/pages/intelligence/components/Filter/util';
import { useDispatch, useSelector } from 'umi';
import { GuideCompetitorDelay as GuideCompetitor } from '@intelligence/components/UserGuide/Competitor';
import ArrowdownText from '@/pages/intelligence/components/ArrowdownText';
import { TopchartPageId, PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import CascaderMetricSelect from '@intelligence/components/CascaderMetricSelect';
import {
  getPCConsoleMetricValues,
  getDeviceOptionByType,
  getCombineTopchartDeviceParams,
} from '@intelligence/pages/TopCharts/PCGames/_config/utils';
import { filterDisabledSourceMetrics, ensureWishlistsMetricSelectionByFilterValue } from '@intelligence/pages/TopCharts/PCConsoleGames/utils/metricSelectorHelpers';
import { buildOrderMetricsFromTableColumns } from '@intelligence/components/ExportTable/components/DownloadSettingModal/utils';
import { PCConsoleSegementList } from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { getPublisherClassText, getClientDataSourceOfCombineMetricsTable } from '@intelligence/pages/TopCharts/PCConsoleGames/utils';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import type { PCConsoleTopChartsPropsType } from '@intelligence/types/topchart';
import { getSeparatedDevicesOfDeviceCategories } from '@intelligence/utils/topchartsUtils';
import { GSD_SOURCE_KEY } from '@intelligence/_config/sourceMetric';
import { ChangeSegementFunType } from '@intelligence/components/ChartsComponents/DataSourceMetricSelector';
import SummaryCard from '@/pages/intelligence/components/SummaryCard';
import SourceExplanation from '@/pages/intelligence/components/SummaryCard/components/SourceExplanation';
import useSummarySourceState from '@/pages/intelligence/components/SummaryCard/useSummarySourceState';
import {
  SUMMARY_SOURCE_LIST,
  SUMMARY_SOURCE_LIST_WITH_DATABRAIN,
  PCCONSOLE_SOURCE_LIST,
  PCCONSOLE_SOURCE_LIST_WITH_DATABRAIN,
} from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/OverlapSteam/constants/metrics';
import {
  defaultMetaScore,
  defaultMetacritic,
  gameModeColumn,
  gameEngineColumn,
  steamTagsColumn,
} from '@intelligence/pages/TopCharts/PCGames/MetricsTable/utils/constant';
import FilterTipModal from '@intelligence/pages/TopCharts/PCGames/components/FilterTipModal';
import classnames from 'classnames';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { handlePCConsoleTopChartsFilterParamsToApi as handleFilterToApiParams } from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FILTER_URL_CONFIG } from '@intelligence/_config/components/filterUrl/pcConsoleTopCharts';
import { TOPCHARTS_METRICS_INHERIT_QUERY_KEY } from '@intelligence/_config/components/filterUrl/kpiTrends';
import {
  DEFAULTKPITRENDSSHOWRTLIST,
  getMetricOptionByValue,
  getSourceMetricsByValue,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/components/MetricsSelection/config';
import '@/pages/intelligence/assets/scss/TopCharts/PCGames/index.scss';
import filtersConfig from '@intelligence/_config/components/filters';
import { fetchCommonTopChartsList } from '@intelligence/services/topcharts';
import useGSDOptions from '@intelligence/pages/TopCharts/_hooks/useGSDOptions';
import useFilterTagsOptions from '@intelligence/hooks/useFilterTagsOptions';
import useCombineGameEngineOptions from '@intelligence/hooks/useCombineGameEngineOptions';
import useHotTagsOptions from '@intelligence/hooks/useHotTagsOptions';
import { parseUrlFilterParams } from '@intelligence/v3/utils/filterTagNameAnalyser';
import { INTELLIGENCE_FILTER_MODAL_NO_LONGER_PROMPT } from '@intelligence/pages/TopCharts/PCGames/components/FilterTipModal/index';
import { getTipModalConfirmStatus } from '@intelligence/pages/TopCharts/PCGames/components/FilterTipModal/utils';
import { seachRecordListPlus } from '@/pages/intelligence/services/common';
import useSetQueryDefinition, { useQueryDefinition } from '@intelligence/hooks/useQueryDefinition';
import { areArraysEqualOrdered, feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';
import moment from 'moment';
import {
  updateShortLinkPath,
  URL_CHART_TYPE,
  URL_SORT_NAME,
  URL_ORDER,
  URL_RATIO_TYPE,
  URL_SHORT_LINK_NAME,
} from '@intelligence/utils/urlPathCfg';
import { getPlatformCacaderValues, buildMetricConditionFromPlatformCascader } from '@intelligence/pages/TopCharts/_config/topchartFilterCfg';
import useSearchParams from '@gp/hooks/useSearchParams';
import useConfigureTexts from '@intelligence/hooks/useConfigureTexts';
import { handleMetricExplanationTipsClick } from '@intelligence/v3/utils/topcharts';
import usePcConsoleMetricSelector from '@intelligence/pages/TopCharts/PCConsoleGames/hooks/usePcConsoleMetricSelector';
import usePcConsoleFilters from '@intelligence/pages/TopCharts/PCConsoleGames/hooks/usePcConsoleFilters';
import ChangedMetricSelect from '@intelligence/v3/components/ChangedMetricSelect';
import {
  getPCConsoleSurgeMetricOptions,
  getSurgeMetricConfig,
  hasSelectedSurgeMetric,
} from '@intelligence/pages/TopCharts/PCConsoleGames/utils/surgeMetricUtils';
import { SortType } from '@home/enums/common';
import { getGranularityAUMetricKey } from '@intelligence/v3/utils/metric';
const { Content } = Layout;
const DEFAULT_PAGE_SIZE = 50;
// Steam 快捷勾选按钮的配置
const STEAM_METRIC_SHORTCUT_OPTIONS = [
  {
    text: 'Steam',
    textCN: 'Steam',
    type: 'steam',
    value: [
      'steamData###source_steam__pcu',
      'steamData###source_steam__acu',
      'steamData###steamfollowers',
      'alinea###alinea__est_cumulative_revenue',
      'alinea###alinea__est_revenue',
      'alinea###alinea__est_cumulative_units',
      'alinea###alinea__est_units',
      'alinea###alinea__est_price',
      'alinea###alinea__wishlists_total',
    ],
  },
];
const PC_CONSOLE_DIRECT_FILTER_URL_KEYS = [
  'companies',
  'publisher_classes',
  'publisher_regions',
  'developers',
  'wishlists_min',
  'wishlists_max',
];

// PC & Console 合并榜单Metrics Table Tab默认展示这些静态列（Metacritic score、Steam tags、Steam game mode、Game engine），
// 这样即使用户取消其他指标，也能看到统一的健康信号；如需关闭可通过 appendCombineExtras。
const COMBINE_STATIC_COLUMNS = [defaultMetaScore, steamTagsColumn, gameModeColumn, gameEngineColumn];

const encodeMetricsUrlParamsValue = (sourceMetrics?: IRecord) => {
  if (!isEmpty(sourceMetrics)) {
    return '';
  }

  return Object.entries(sourceMetrics as IRecord)
    .map(([source, metrics]) => `${source}::${metrics?.join(',') || ''}`)
    .join(';;') || '';
};

// PCConsoleTopCharts页面，后续pc/console榜单也会使用此页面
const PCConsoleTopCharts = (props: PCConsoleTopChartsPropsType) => {
  const {
    entityType,
    pageId, // 页面特有ID标识
    businessType,
    downloadKey,
    hasUrlShortLink,
    appendCombineExtras,
    sortByFront = false,
    gameHightList,
    visualLoadingHeight = 402,
    isStudio = false,
    // 可视化标签联动表格排序
    visualLinkTable = false,
    defaultPageSize = DEFAULT_PAGE_SIZE,
    hasExtend = true,
    hasSearch = true,
    downloadModalSize = 820,
    firstDownLoadBubleShow,
    setFirstDownLoadBubleShow = () => {},
    checkboxDisableTip,
    initialMetricSelectorValues,
    initialMetricSelectorOptions,
    tableColumnsListCur,
    rangeTimeComponentDefault,
    defaultParams,
    pageLogKey = 'topChartsPCConsoleGamesMetricsTable',
    pageLogInfo = dbiPageLogMes.topChartsPCConsoleGamesMetricsTable,
    jumpQuery,
  } = props;
  const { chart_type } = useSearchParams();
  const shouldDecodeFilterUrl = useMemo(() => {
    if (typeof window === 'undefined') return false;
    const params = new URLSearchParams(window.location.search);
    if (params.has(URL_SHORT_LINK_NAME)) return false;
    return PC_CONSOLE_DIRECT_FILTER_URL_KEYS.some((key) => params.has(key));
  }, []);
  const { formatMessage, locale } = useIntlExtend();
  const { configureTexts } = useConfigureTexts();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });
  const {
    pcConsoleCascaderMetricsOptions: defaultCascaderOptions,
    pcConsoleCascaderMetricsMap: defaultCascaderMap,
    pcConsoleDefaultMetrics: defaultMetricKeys,
  } = PCConsoleSegementList;
  const cascaderOptions = props?.pcConsoleCascaderMetricsOptions || defaultCascaderOptions;
  const cascaderMap = props?.pcConsoleCascaderMetricsMap || defaultCascaderMap;
  const metricKeys = props?.pcConsoleDefaultMetrics || defaultMetricKeys;
  // GSD device的options集合（级联）
  const { combineDevices: gsdDevices } = useGSDOptions();
  const isPCConsoleMetricsTable = pageId === TopchartPageId.PCConsoleMetricsTable;
  const chartTypeCur = useRef<any>(null);
  const defaultMetricList = getDataSourcesMetricsByTopChartsType(entityType + pageId) || [];
  const dataBrainCalibrationPageId =
  (TopchartPageId as Record<string, string | undefined>)?.PCConsoleDataBrainCalibration ||
  'PCConsoleDataBrainCalibration';
  const isDataBrainCalibration = useMemo(
    () => typeof pageId === 'string' && pageId.toLowerCase() === dataBrainCalibrationPageId.toLowerCase(),
    [pageId, dataBrainCalibrationPageId],
  );
  const shouldUpdateMetricsOnFilterChange = isPCConsoleMetricsTable || isDataBrainCalibration;
  const shouldAppendCombineExtras =
    typeof appendCombineExtras === 'boolean' ? appendCombineExtras : entityType === 'combine';
  const summarySourceKeyList = useMemo(
    () => (isDataBrainCalibration ? PCCONSOLE_SOURCE_LIST_WITH_DATABRAIN : PCCONSOLE_SOURCE_LIST),
    [isDataBrainCalibration],
  );
  const summarySourceList = useMemo(
    () => (isDataBrainCalibration ? SUMMARY_SOURCE_LIST_WITH_DATABRAIN : SUMMARY_SOURCE_LIST),
    [isDataBrainCalibration],
  );

  // 获取国家地区选项数据
  // 获取公共筛选配置
  const regionOptions = useQueryDefinition('metricTableRegionCountry');
  const publisherClassCombine = useQueryDefinition('publisherClassCombine');

  const { steamTagOptions, gameModeOptions } = useFilterTagsOptions();
  const { combineGameEngineOptions } = useCombineGameEngineOptions();
  const publisherClassOptions = useMemo(() => {
    const options = Array.isArray(publisherClassCombine) ? publisherClassCombine : [];

    return options.map((item: string) => ({
      value: item,
      text: getPublisherClassText(item, formatMessage),
    }));
  }, [formatMessage, publisherClassCombine]);

  // 品类 options（用于 HotTag 解析品类筛选器参数）
  const { genreOptionsMap } = useQueryDefinition();
  const genreOptionsMapRef = React.useRef(genreOptionsMap);
  genreOptionsMapRef.current = genreOptionsMap;

  // 热门标签选项（entityType = 'combine'）
  const { hotTagsOptions, filterTagName, hotTagsLoading } = useHotTagsOptions('combine');
  const [selectedHotTagOption, setSelectedHotTagOption] = React.useState<any>(null);
  const [hotTagDefaultOption, setHotTagDefaultOption] = React.useState<any>(null);

  // CommonFilter ref，用于 HotTag 选中时调用 setValueAndConfirm 触发请求
  const commonFilterRef = React.useRef<ICommonFilterInstance | null>(null);

  React.useEffect(() => {
    if (!filterTagName || hotTagsLoading || !hotTagsOptions.length) return;
    const matchedOption = hotTagsOptions.find((opt: any) => opt?.name === filterTagName);
    if (!matchedOption?.value) return;
    setSelectedHotTagOption(matchedOption);
    setHotTagDefaultOption(matchedOption);
  }, [filterTagName, hotTagsLoading, hotTagsOptions]);

  // HotTagsSource 选中时调用：只回填页面筛选器状态，真正请求交给确认按钮
  const handleHotTagConfirm = React.useCallback(async (option: any) => {
    if (!option?.value) return;
    setSelectedHotTagOption(option);
    try {
      const parsedValue = await parseUrlFilterParams(option.value, { genreOptionsMap: genreOptionsMapRef.current });
      if (parsedValue && Object.keys(parsedValue).length > 0) {
        const nextFilterValue = {
          ...(filterCfg?.defaultValue || {}),
          ...parsedValue,
          [filterKeyMap.HOT_TAGS_SOURCE]: { value: option },
        };
        setFilterValue(nextFilterValue);
      }
    } catch (err) {
      console.error('[PCConsoleTopCharts] handleHotTagConfirm failed:', err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const filterConfigCur = useMemo(() => {
    return filtersConfig[pageId];
  }, [pageId]);

  const hasMetricSelectorChanged = useRef<boolean>(Boolean(getURLSearchParams('custom_metrics')));
  const [hasManuallySelectedMetrics, setHasManuallySelectedMetrics] = useState(false);
  const userManuallyChangedRegionRef = useRef<boolean>(Boolean(getURLSearchParams('custom_region')));
  const prevFilterValue = useRef<any>();
  const metricValueRangeTime = useRef<any>({});

  const {
    filterValue,
    setFilterValue,
    filterPageValue,
    setFilterPageValue,
    filterCfg,
    formatFilterValuesFromUrl,
    getRadioOptionsTips,
    genreOptionsMapLoading,
    formatedGenreOptionsMap,
  } = usePcConsoleFilters({
    pageId,
    entityType,
    filterConfigCur,
    initialMetricSelectorValues,
    rangeTimeComponentDefault,
    defaultParams,
    configureTexts,
    regionOptions,
    steamTagOptions,
    gameModeOptions,
    gameEngineOptions: combineGameEngineOptions,
    publisherClassOptions,
    hasUrlShortLink,
    filterKeyMap,
    FilterTimeType,
    formatMessage,
    userManuallyChangedRegionRef,
    hasMetricSelectorChangedRef: hasMetricSelectorChanged,
    hotTagsOptions,
    filterTagName,
    hotTagDefaultOption,
    onHotTagConfirm: handleHotTagConfirm,
  });
  // const [metricFilterValue, setMetricFilterValue] = useState<string[]>([]);
  // 自定义宽表 metric 后，筛选器变更提示弹窗
  const [filterTipModalVisible, setFilterTipModalVisible] = useState<boolean>();
  const [noSuitableMsg, setNoSuitableMsg] = useState(formatMessage({ id: 'common_nodata' }));
  const [metricSegVal, setMetricSegVal] = useState(SteamSalesList[0].value);
  // 在筛选器这里拿到缓存的值，并渲染
  const filterSaveName = hasExtend ? getFilterName(userInfo) : '';
  // const filterSaveData = hasExtend ? getFilterValueStorage(userInfo) : {};
  const { setFilterExtend, setDetailFilterExtend } = useFilterExtend({ pageId });

  // 保留每次的 filterValue ，用于对比当前点击 confirm 时是否发生变化
  // （初始 ref 定义已在 usePcConsoleFilters 之前声明）
  // 是否是 reset 后点击 confirm 查询
  const afterResetOnConfirmRef = useRef<boolean>();

  const {
    fetchParams,
    initialResetTime,
    tableTotal,
    tableData,
    chartType,
    setChartType,
    barOrPieData,
    setBarOrPieData,
    lineData,
    getGameData,
    getLineChartData,
    defaultSelectionGames,
    isNewComfirm,
    setIsNewComfirm,
    isNewCheckGame,
    setIsNewCheckGame,
    tableSelection,
    operatedGame,
    setOperatedGame,
    setTableSelection,
    isNodata,
    handleClearSearch,
    transTableDataForSearch,
    handleSortByFront,
    trendLoading,
    tableLoading,
    isVisualisLoading,
  } = usePCConsoleGamesModel({
    entityType,
    defaultParams,
    getTableApiFun: fetchCommonTopChartsList,
    getTrendApiFun: fetchCommonTopChartsList,
    filterValue,
    setFilterValue,
    setFilterPageValue,
    hasUrlShortLink,
    sortByFront,
    fixedSelection: gameHightList,
    metricValueRangeTime,
    chartTypes: chart_type,
  });
  const [metric, setMetric] = useState(defaultMetricList?.[0]?.value || metricKeys?.[0] || '');

  // 点击筛选器 Reset 时，日期筛选器需还原为"页面初始化时首次确定的日期"。
  // 将该冻结日期合并进 rangeTimeComponentDefault 对应粒度，让 CommonFilter 现有的
  // Reset 逻辑（读取 rangeTimeComponentDefault[type]）直接命中，无需额外配置字段。
  // initialResetTime 在首个数据接口返回后冻结，不随后续粒度/筛选变化。
  const rangeTimeComponentDefaultForReset = useMemo(() => {
    if (!initialResetTime?.start_date || !initialResetTime?.end_date) {
      return rangeTimeComponentDefault;
    }
    const filterTimeType = feachTimeTypeToFilterTimeType(initialResetTime.date_type);
    return {
      ...rangeTimeComponentDefault,
      [filterTimeType]: [moment(initialResetTime.start_date), moment(initialResetTime.end_date)],
    };
  }, [rangeTimeComponentDefault, initialResetTime]);

  const {
    metricSelectorOptions,
    metricSelectorValues,
    dataSourcesColumns,
    setDataSourcesColumns,
    sortByKey,
    setSortByKey,
    sortByName,
    setSortByName,
    updateMetricsAndSetValues,
    changeMetricSelector,
  } = usePcConsoleMetricSelector({
    entityType,
    pageId,
    cascaderOptions,
    cascaderMap,
    metricKeys,
    initialOptions: initialMetricSelectorOptions,
    initialValues: initialMetricSelectorValues,
    initialColumns: tableColumnsListCur,
    defaultMetacritic,
    shouldAppendCombineExtras,
    defaultPageSize,
    shouldUpdateMetricsOnFilterChange,
    isPCConsoleMetricsTable,
    metricValueRangeTimeRef: metricValueRangeTime,
    userManuallyChangedRegionRef,
    hasMetricSelectorChangedRef: hasMetricSelectorChanged,
    filterConfigCur,
    filterValue,
    setFilterValue,
    setFilterPageValue,
    setFilterExtend,
    setDetailFilterExtend,
    formatMessage,
    dispatch,
    setMetric,
    setOperatedGame,
    getData,
    getPCConsoleMetricValues,
  });

  const resolvedDataSourcesColumns = useMemo(
    () => (shouldAppendCombineExtras ? [...dataSourcesColumns, ...COMBINE_STATIC_COLUMNS] : dataSourcesColumns),
    [shouldAppendCombineExtras, dataSourcesColumns],
  );

  const detailJumpQuery = useMemo(() => {
    const query = { ...jumpQuery };
    const selectedMetrics = metricSelectorValues?.map((value) => cascaderMap?.[value])?.filter(Boolean) || [];
    const selectedSourceMetrics = getPCConsoleMetricValues(selectedMetrics)?.source_metrics || {};
    const selectedMetricValues = Object.values(selectedSourceMetrics)?.flat() || [] as string[];
    const selectedKpiMetrics = getMetricOptionByValue(selectedMetricValues)?.map((option: any) => option?.value) || [];
    const sourceMetrics = hasManuallySelectedMetrics && selectedKpiMetrics?.length
      ? getSourceMetricsByValue(selectedKpiMetrics)
      : getSourceMetricsByValue(DEFAULTKPITRENDSSHOWRTLIST);

    if (hasManuallySelectedMetrics && selectedKpiMetrics?.length) {
      query.metrics = encodeMetricsUrlParamsValue(sourceMetrics);
      query[TOPCHARTS_METRICS_INHERIT_QUERY_KEY] = '1';
    } else if (!isDataBrainCalibration) {
      query.metrics = encodeMetricsUrlParamsValue(sourceMetrics);
    }

    return query;
  }, [cascaderMap, hasManuallySelectedMetrics, isDataBrainCalibration, jumpQuery, metricSelectorValues]);

  // 异动指标选项 - 根据日期粒度动态生成
  const surgeMetricOptions = useMemo(() => {
    return getPCConsoleSurgeMetricOptions(fetchParams?.date_type);
  }, [fetchParams?.date_type]);

  // 异动指标状态
  const [surgeMetric, setSurgeMetric] = useState('');

  const getDefaultOrderMetricData = (metricValues: string[]) => {
    const defaultOrderMetricCategory = 'revenue';
    const defaultOrderMetricDataSource = 'mscience';
    const defaultOrderMetricKey = 'digitalRevenue';
    const defaultMetricValue = `${defaultOrderMetricCategory}###${defaultOrderMetricKey}`;

    if (metricValues?.includes(defaultMetricValue)) {
      return { dataSource: defaultOrderMetricDataSource, metric: defaultOrderMetricKey };
    }

    const firstMetricSelectorValue = metricValues?.[0];
    const firstMetricData = cascaderMap?.[firstMetricSelectorValue];

    return { dataSource: firstMetricData?.dataSource || '', metric: firstMetricData?.value || '' };
  };

  /**
   * 异动指标变更处理
   * 选择异动指标后，自动勾选对应指标并重新请求数据
   * 如果异动指标对应的排序指标与当前排序指标不一致，自动更新排序指标
   */
  const handleSurgeMetricChange = async (value: string) => {
    setSurgeMetric(value);

    if (!value) {
      const defaultOrderMetricData = getDefaultOrderMetricData(metricSelectorValues);
      // 清空异动指标时，恢复默认榜单
      const newFetchParams = {
        ...fetchParams,
        order_source: defaultOrderMetricData?.dataSource || '',
        order_metric: defaultOrderMetricData?.metric || '',
        order: SortType.Desc,
        ratio_type: 0,
        surge_metric: '',
        page: 1,
      };
      getData({
        params: newFetchParams,
        isCheckGame: operatedGame,
        isSearch: false,
        isUpdateLineChart: !operatedGame,
      });
      return;
    }

    // 获取异动指标对应的页面指标key
    const surgeMetricConfig = getSurgeMetricConfig(value);
    const targetMetricKey = surgeMetricConfig?.pageMetricKey;

    // 检查指标是否已勾选
    const isAlreadySelected = hasSelectedSurgeMetric(value, metricSelectorValues, cascaderMap);

    // 构建新的指标列表
    let newMetricValues = [...metricSelectorValues];
    if (targetMetricKey && !isAlreadySelected) {
      newMetricValues = [...newMetricValues, targetMetricKey];
    }

    // 判断是否需要更新排序指标（异动指标对应的排序指标与当前不一致时才更新）
    const needsSortUpdate = surgeMetricConfig &&
      (fetchParams?.order_metric !== surgeMetricConfig?.order_metric ||
       fetchParams?.order_source !== surgeMetricConfig?.order_source);

    // 构建请求参数
    let newFetchParams = {
      ...fetchParams,
      ratio_type: 1,
      surge_metric: value,
      page: 1,
    };

    // 如果排序指标不一致，更新排序参数
    if (needsSortUpdate) {
      newFetchParams = {
        ...newFetchParams,
        order_source: surgeMetricConfig.order_source,
        order_metric: surgeMetricConfig.order_metric,
        order: SortType.Desc, // 默认降序
      };

      // 更新排序相关的 UI 状态
      if (targetMetricKey && cascaderMap[targetMetricKey]) {
        setSortByKey(targetMetricKey);
        setSortByName(cascaderMap[targetMetricKey]?.text || '');
      }
    }

    if (!isAlreadySelected && targetMetricKey) {
      // 需要更新指标选择
      await changeMetricSelector({
        payload: newMetricValues,
        fetchParams: newFetchParams,
      });
    } else {
      // 直接请求数据
      getData({
        params: newFetchParams,
        isCheckGame: operatedGame,
        isSearch: false,
        isUpdateLineChart: !operatedGame,
      });
    }
  };

  const getShouldShowTipModal = (filter: any) => {
    // 未自定义选中宽表 metric 不显示
    if (!hasMetricSelectorChanged.current) return false;

    // Reset 触发的时间粒度、国家变化，不显示
    if (afterResetOnConfirmRef.current) {
      afterResetOnConfirmRef.current = false;
      return false;
    }

    // 有勾选不再提示保存到 localStorage 的，不显示
    const noLongerPrompt = localStorage?.getItem(INTELLIGENCE_FILTER_MODAL_NO_LONGER_PROMPT);
    if (noLongerPrompt) return false;

    // 地区、日期类型有变动才显示
    const keys = [
      ['region', 'regions'],
      ['rangeTime', 'type'],
    ];

    const shouldShowTipModal = keys.some((item) => {
      const [key, subKey] = item;
      return filter?.[key] && filterPageValue?.[key] && !isEqual(filterPageValue?.[key][subKey], filter?.[key][subKey]);
    });

    return shouldShowTipModal;
  };

  // More Filter按钮埋点
  const onToggleMoreFilter = (v: boolean) => {
    if (v) {
      const logKey = `${entityType}_${pageId}_MetricsMoreFilter`;
      const logConfig = dbiTopChartsBtnLogMes?.[logKey];
      logConfig && buriedBtnPoint(logConfig);
    }
  };

  // 统一处理指标筛选器修改，转换成source_metrics

  /**
   * 筛选器统一值处理后，confirm回调
   */
  const fetchFilterChange = async (payload: any, apiValue: any, urlCustomParams: any) => {
    // console.log('fetchFilterChange-payload', payload);
    let fetchParamsCur = fetchParams;

    const metricValueList = payload[filterKeyMap.PCCONSOLE_TOPCHARTS_METRICS]?.value || [];

    let metricSelectorValuesLet = metricValueList.length > 0 ? metricValueList : metricSelectorValues;
    metricSelectorValuesLet = ensureWishlistsMetricSelectionByFilterValue(metricSelectorValuesLet, payload);

    let isNeedLineChartDataValue = false;
    // 如果url参数不为空
    if (!isEmpty(urlCustomParams)) {
      fetchParamsCur = {
        ...fetchParamsCur,
        ...urlCustomParams?.params,
      };
      isNeedLineChartDataValue = urlCustomParams?.isNeedLineChartDataValue;
    }

    // 点击 confirm 按钮时筛选项发生变化时才更新宽表 metrics
    const filterValueHasChanged = !isEqual(prevFilterValue.current, payload);
    prevFilterValue.current = cloneDeep(payload);

    const params = handleFilterToApiParams(fetchParamsCur, payload, apiValue);

    let newParamsValue = {
      ...params,
      page: 1,
      page_size: defaultPageSize,
    };

    // 检查异动指标是否与新粒度匹配
    const auMetrics = ['dau', 'mau'];
    const newDateType = params?.date_type || fetchParams?.date_type;
    if (surgeMetric && auMetrics.includes(surgeMetric)) {
      // 根据新粒度推导出对应的 AU 指标
      const expectedSurgeMetric = getGranularityAUMetricKey(newDateType);

      if (surgeMetric !== expectedSurgeMetric) {
        // 粒度不匹配，更新异动指标
        // 如果 expectedSurgeMetric 在支持的列表中则更新，否则清空
        // const finalSurgeMetric = auMetrics.includes(expectedSurgeMetric) ? expectedSurgeMetric : '';
        const finalSurgeMetric = '';
        setSurgeMetric(finalSurgeMetric);
        newParamsValue.surge_metric = finalSurgeMetric;
      }
    }

    // check 因时间粒度、国家原因更新Metrics下拉选择值，更新参数
    const { params: updatedParamsValue, updatedMetricValues } = updateMetricsAndSetValues(
      newParamsValue,
      shouldUpdateMetricsOnFilterChange,
      filterValueHasChanged,
      // 宽表 metric 没有改变时沿用默认逻辑，参数传 true，发生改变时传 false，不重新添加默认值，不过滤掉禁用options的值
      !hasMetricSelectorChanged.current,
      metricSelectorValuesLet,
    );
    newParamsValue = updatedParamsValue;

    // 过滤掉被禁用的指标：根据当前筛选条件计算可用的指标列表，过滤 source_metrics
    // 使用 updateMetricsAndSetValues 更新后的指标值（含粒度切换后新增的默认指标，如 ampere），避免遗漏
    const effectiveMetricValues = updatedMetricValues || metricSelectorValuesLet;
    const { availableMetricValues, sourceMetrics, orderSource, orderMetric } = filterDisabledSourceMetrics(
      newParamsValue,
      pageId,
      cascaderOptions,
      effectiveMetricValues,
      cascaderMap,
      getPCConsoleMetricValues,
    );
    newParamsValue.source_metrics = {
      ...sourceMetrics,
      ...(shouldAppendCombineExtras ? defaultMetacritic : {}),
    };
    // 更新排序字段为校验后的值
    newParamsValue.order_source = orderSource;
    newParamsValue.order_metric = orderMetric;

    // 当用户选择 Global WO China 时，自动按已选的首个 Ampere 指标降序排列
    const isGlobalWoChina = payload?.[filterKeyMap.REGION]?.markets?.[0] === 'global_wo_china';
    if (isGlobalWoChina) {
      const extractMetricKey = (raw: string) => raw?.split('###').pop() || '';
      // 使用粒度过滤后的 availableMetricValues 而不是过时的 effectiveMetricValues
      const firstAmpereKey = availableMetricValues
        ?.map(extractMetricKey)
        .find((key: string) => key.startsWith('ampere_'));

      if (firstAmpereKey) {
        newParamsValue.order_source = 'ampere';
        newParamsValue.order_metric = firstAmpereKey;
        newParamsValue.order = 'desc';
      }
    }
    // 更新 metricSelectorValuesLet 为过滤后的可用指标，并同步清洗后的指标选中态/表格列
    metricSelectorValuesLet = availableMetricValues;

    // 当时间粒度等筛选项变化导致默认指标自动调整时，
    // updateMetricsAndSetValues 仅更新了 metricSelectorValues，未同步回 filterValue。
    // 这里显式回写，确保依赖 filterValue.pcConsole_topCharts_metrics.value 的派生计算能立即响应。
    const submittedMetricValues = payload?.[filterKeyMap.PCCONSOLE_TOPCHARTS_METRICS]?.value || [];
    if (!areArraysEqualOrdered(submittedMetricValues, metricSelectorValuesLet)) {
      const syncedFilterValue = {
        ...payload,
        [filterKeyMap.PCCONSOLE_TOPCHARTS_METRICS]: {
          ...(payload?.[filterKeyMap.PCCONSOLE_TOPCHARTS_METRICS] || {}),
          value: metricSelectorValuesLet,
        },
      };
      setFilterValue(syncedFilterValue);
      setFilterPageValue(syncedFilterValue);
    }
    const cleanedTableColumns = metricSelectorValuesLet
      .map((item: any) => cascaderMap?.[item])
      .filter(Boolean);
    if (metricSelectorValuesLet.length > 0) {
      updateMetricsAndSetValues(
        newParamsValue,
        shouldUpdateMetricsOnFilterChange,
        true,
        false,
        metricSelectorValuesLet,
      );
    }

    /** 修改筛选器后，游戏应该重置为未勾选状态 */
    setOperatedGame(false);
    // 如果是链接中带有当前时间粒度禁用的宽表 metrics,需要 metrics 选择器对应选项禁用态
    const myFilterValue = payload?.[filterKeyMap.MY_FILTER]?.value;

    // 更新短链接参数
    // const query: any = {
    //   [URL_CHART_TYPE]: chartType,
    //   [URL_SORT_NAME]: newParamsValue.order_metric,
    //   [URL_ORDER]: newParamsValue.order,
    //   [URL_RATIO_TYPE]: newParamsValue.ratio_type,
    // };
    // updateShortLinkPath({
    //   shortLinkQuery: query,
    // });
    getData({
      params: newParamsValue,
      isCheckGame: false,
      isSearch: false,
      isUpdateLineChart: true,
      updateFilterValues: payload,
      myFilterValue,
      metricFilterValue: metricSelectorValuesLet,
      tableColumns: cleanedTableColumns.length > 0 ? cleanedTableColumns : dataSourcesColumns,
      isNeedLineChartDataValue,
    });

    setIsNewComfirm(true);
    setIsNewCheckGame(true);
  };
  // filter公共hooks，暴露全局统一处理filterValue方法，再调接口
  const { updateFilterDatas } = useInitFilterHook({
    executable: !genreOptionsMapLoading,
    entityType,
    filterCfg,
    filterValue,
    setFilterValue,
    setFilterPageValue,
    filterConfirm: fetchFilterChange,
    // isBasicLoading: filterLoading,
    ifGetFilterExtend: false,
    ifSetFilterExtend: true,
    hasUrlShortLink,
    pageId,
    dataSourcesColumns,
    setDataSourcesColumns,
    setChartType,
    setMetric,
    genreOptionsMap: formatedGenreOptionsMap,
    needDecodeUrl: shouldDecodeFilterUrl,
    filterConfig: FILTER_URL_CONFIG,
    filterValueFormatter: formatFilterValuesFromUrl,
  });

  // 参照 Mobile ActiveUsers: 排序/图表类型等变化时，通过 updateShortLinkPath 更新 URL query 参数（保留 filters_key）
  useEffect(() => {
    if (hasUrlShortLink) {
      updateShortLinkPath({
        shortLinkQuery: {
          [URL_CHART_TYPE]: chartType,
          [URL_SORT_NAME]: fetchParams?.order_metric,
          [URL_ORDER]: fetchParams?.order,
          [URL_RATIO_TYPE]: fetchParams?.ratio_type,
        },
      });
    }
  }, [
    hasUrlShortLink,
    chartType,
    fetchParams?.ratio_type,
    fetchParams?.order_metric,
    fetchParams?.order,
  ]);

  const handleMetricSelectorChange = async (payload: string[]) => {
    if (!areArraysEqualOrdered(payload, metricSelectorValues)) {
      setHasManuallySelectedMetrics(true);
    }

    const shouldResetSurgeMetric = Boolean(surgeMetric && !hasSelectedSurgeMetric(surgeMetric, payload, cascaderMap));

    if (shouldResetSurgeMetric) {
      setSurgeMetric('');
      await changeMetricSelector({
        payload,
        fetchParams: {
          ...fetchParams,
          order: SortType.Desc,
          ratio_type: 0,
          surge_metric: '',
          page: 1,
        },
      });
      return;
    }

    await changeMetricSelector({ payload, fetchParams });
  };

  const [deviceSortByList, setDeviceSortByList] = useState<any[]>([]);

  const metricSelectorValuesForDownload = useMemo<[string, string][]>(() => {
    if (entityType !== PC_CONSOLE_COMBINE_ENTITY_TYPE) return [];
    if (!Array.isArray(metricSelectorValues)) return [];
    const dataSourceMetrics: [string, string][] = [];
    const dataSourcesMap: {
      [key: string]: string;
    } = {
      mscience: 'Mscience',
    };
    for (const metricSelectorValue of metricSelectorValues) {
      const { dataSource, value: metric } = cascaderMap?.[metricSelectorValue] || {};
      if (dataSource && metric) {
        const dataSourceTmp = dataSourcesMap[dataSource] || dataSource;
        dataSourceMetrics.push([dataSourceTmp, metric]);
      }
    }
    return dataSourceMetrics;
  }, [entityType, metricSelectorValues, cascaderMap]);

  // 数据源提示hooks
  const { openSource, handleClickSourceTips } = useSummarySourceState();

  // 切换charts类型事件
  const handleChartMetricType = (value: ChartType) => {
    if (value === ChartType.Line && tableSelection?.length && isNewComfirm && isNewCheckGame) {
      const idList = tableSelection.map((t) => t?.gameId);
      const trendParams = isDataBrainCalibration ? { ...fetchParams, b_true_data: true } : fetchParams;
      getLineChartData(trendParams, idList, dealParams);
    }
    setChartType(value);
    // 更新url参数-可视化类型（通过 updateShortLinkPath 只更新query参数，保留 filters_key）
    updateShortLinkPath({ shortLinkQuery: { [URL_CHART_TYPE]: value } });
    chartTypeCur.current = value;
  };

  const handleSortByFetchApi = (newFetchParams: any, sortFun: Function) => {
    // if (!operatedGame) {
    //   /** 没有勾选时点排序则重新Loading柱状图数据 */
    //   setIsVisualisLoading(true);
    // }
    sortFun?.({
      list: tableData,
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: !operatedGame,
    });
  };
  const dealParams = (params: any) => {
    return {
      ...params,
      metric_condition: merge(
        buildMetricConditionFromPlatformCascader(params?.platform_cascader),
        params.metric_condition,
      ),
    };
  };
  function getData(args: {
    params: any;
    isCheckGame: boolean;
    isSearch?: boolean;
    isUpdateLineChart: boolean;
    updateFilterValues?: any;
    myFilterValue?: string;
    metricFilterValue?: string[];
    tableColumns?: any[];
    isNeedLineChartDataValue?: boolean;
  }) {
    const {
      params,
      isCheckGame,
      isSearch = false,
      isUpdateLineChart = true,
      updateFilterValues = filterValue,
      myFilterValue = filterSaveName,
      metricFilterValue = metricSelectorValues,
      tableColumns = dataSourcesColumns,
      isNeedLineChartDataValue = false,
    } = args;

    const paramsWithTrueData = isDataBrainCalibration ? { ...params, b_true_data: true } : params;

    // 对Device做拆分拿到排序列表
    const deviceMap = {
      PC: ['PC'],
      PlayStation: ['PS4', 'PS5'],
      Xbox: ['XOne', 'XS X|S'],
      Nintendo: ['Wii U', 'NS'],
    } as any;

    const devices: string[] = paramsWithTrueData?.device || [];
    let deviceList: string[] = [];

    devices.forEach((device) => {
      if (deviceMap[device]) {
        deviceList = [...deviceList, ...deviceMap[device]];
      }
    });
    const sortByList = deviceList?.map((t) => ({
      key: `meta_score_${t}_metacritic_0`,
      order_device: t,
      sortMetric: 'meta_score',
      orderSource: 'metacritic',
      text: t,
      title: formatMessage({ id: 'dbi_metric_metacritic_global' }),
      ratioType: 0,
    }));
    setDeviceSortByList(sortByList);

    const newFormValue = {
      ...paramsWithTrueData,
      unified_ids: isSearch ? paramsWithTrueData?.unified_ids : [],
      source_metrics: {
        ...(paramsWithTrueData?.source_metrics || {}),
        ...(shouldAppendCombineExtras ? defaultMetacritic : {}),
      },
    };
    // console.log('getData', newFormValue);
    // 只有评分才有order_device参数
    newFormValue.order_device = newFormValue?.order_metric === 'meta_score' ? newFormValue.order_device : '';

    getGameData({
      params: newFormValue,
      isCheckOrSearch: isCheckGame,
      isUpdateLineChart,
      updateFilterValues,
      filterSaveName: myFilterValue || '',
      metricFilterValue,
      tableColumns,
      isNeedLineChartDataValue,
      dealParams,
    });
  }

  const onTableSortChage = (e: SortByItemType) => {
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_device: e?.order_device ? e?.order_device : '',
      order_metric: e?.sortMetric,
      order_source: e?.dataSourceNew ?? e?.orderSource,
      ratio_type: e?.ratioType,
      page: 1,
      page_size: defaultPageSize,
    };
    setSortByName(e?.title);
    setSortByKey(e?.sortMetric);
    handleSortByFetchApi(newFetchParams, sortByFront ? handleSortByFront : getData);
  };

  const handleChangeSegement = async (params: ChangeSegementFunType) => {
    // 可视化不用联动表格则不往下走
    if (!visualLinkTable) {
      return;
    }
    const { metric, source, tableSource, currentMetricObj } = params || {};
    const dataSource = currentMetricObj?.tableSource || tableSource || source;
    // 过滤出列表的内容
    onTableSortChage({
      sortMetric: metric,
      orderSource: dataSource,
      ratioType: 0,
      sortVal: 'desc',
    });
  };

  const getTableSearchList = (id: string) => {
    getData({
      params: { ...fetchParams, unified_ids: [id] },
      isCheckGame: true,
      isSearch: true,
      isUpdateLineChart: false,
    });
  };

  const handleDownloadParams = (params: any): any => {
    let paramsTmp: any = {
      ...params,
      pageId,
      select_ids: tableSelection,
    };
    if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE && (isPCConsoleMetricsTable || isDataBrainCalibration)) {
      const devicesParams = params?.device;
      // GSD数据源的devices集合
      const gsdDevicesSeparated = getSeparatedDevicesOfDeviceCategories(gsdDevices, devicesParams);
      // 非GSD数据源的devices的map映射
      const otherDevicesSeparatedMap = getCombineTopchartDeviceParams(devicesParams);
      const sourceDownloadDevicesMap = {
        ...otherDevicesSeparatedMap,
        [GSD_SOURCE_KEY]: gsdDevicesSeparated,
      };
      // 过滤掉被禁用的指标
      const { sourceMetrics, orderSource, orderMetric } = filterDisabledSourceMetrics(
        params,
        pageId,
        cascaderOptions,
        metricSelectorValues,
        cascaderMap,
        getPCConsoleMetricValues,
      );
      const orderMetricsFromTable = buildOrderMetricsFromTableColumns(
        dataSourcesColumns,
      );
      paramsTmp = {
        ...paramsTmp,
        metrics: metricSelectorValuesForDownload,
        source_download_device: sourceDownloadDevicesMap,
        download_metrics: metricSelectorValues,
        order_metrics: orderMetricsFromTable,
        regionOptions,
        isCountriesPage: false,
        tableSelection,
        fp: {
          ...fetchParams,
          source_metrics: sourceMetrics,
          order_source: orderSource,
          order_metric: orderMetric,
        },
      };
    }
    return paramsTmp;
  };

  const devicesOptions = useMemo<SelectOption[]>(() => {
    const options = getDeviceOptionByType(pageId);
    return Array.isArray(options) ? options : [];
  }, [pageId]);

  const devicesNames = useMemo<string>(() => {
    const devices: string[] = fetchParams?.device;
    if (!devices) return '';
    if (!Array.isArray(devices)) return '';
    return devices.map((device) => mapOptionValue2Text(device, devicesOptions)).join(', ');
  }, [devicesOptions, fetchParams?.device]);

  // 下载弹窗表单内 纯文本展示的 文本集合，下载表单配置的纯文本空间的text字段值 对应该对象的key，通过key获取展示的文本内容
  const downloadFormModelTexts = useMemo<{ [key: string]: string }>(
    () => ({
      devices: devicesNames,
    }),
    [devicesNames],
  );

  const onTablePagingChange = (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || defaultPageSize,
    };
    getData({
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: false,
    });
  };

  // 表格列表项选择事件回调
  const onTableCheckGame = (selectList: TableSelectionType[], checkStatus: TableSelectStatusType) => {
    setIsNewComfirm(true);
    setIsNewCheckGame(true);
    const idList = selectList.map((t) => t?.gameId);
    if (chartType === ChartType.Line) {
      const trendParams = isDataBrainCalibration ? { ...fetchParams, b_true_data: true } : fetchParams;
      getLineChartData(trendParams, idList, dealParams);
    }
    /** 是否勾选了游戏 */
    if (checkStatus === 'cancel' || checkStatus === 'all' || selectList.length === 0) {
      setOperatedGame(false);
    } else {
      setOperatedGame(true);
    }
    setBarOrPieData(selectList);
    setTableSelection(selectList);
  };

  const handleSteamCellTagClick = async (type: string, tag: string) => {
    // 将点击的 tag 给对应的筛选器赋值
    const currentFilterValue = { ...filterValue, [type]: { value: [tag] } };
    setFilterValue(currentFilterValue);
    setFilterPageValue(currentFilterValue);

    // 发起请求
    const newFormValue = {
      ...fetchParams,
      [type]: [tag],
    };

    getData({
      params: newFormValue,
      isCheckGame: false,
      isSearch: false,
      isUpdateLineChart: true,
      updateFilterValues: currentFilterValue,
    });
  };

  const handleFilterTipModalConfirm = () => {
    setFilterTipModalVisible(false);
  };

  const handleFilterTipModalCancel = () => {
    setFilterTipModalVisible(false);
  };

  const handleFilterConfirm = async (params: any) => {
    // console.log('...params', ...params);

    // 时间地区修改后且有自定义宽表指标时，提示弹窗
    const shouldShowTipModal = getShouldShowTipModal(params);
    if (shouldShowTipModal) {
      // 显示弹窗
      setFilterTipModalVisible(true);
      // 监听弹窗确认状态
      const tipModalConfirmStatus = await getTipModalConfirmStatus();
      // 撤销：将筛选器的值撤销为上次 confirm 的值
      if (!tipModalConfirmStatus) {
        setFilterValue(filterPageValue);
        return;
      }
    }

    updateFilterDatas(params);
  };

  // 返回页面时清空 metric 相关的共享状态，避免跨页面残留
  useEffect(
    () => () => {
      dispatch({ type: `${DBI_TOPCHARTS}/setMetricValue`, payload: '' });
      dispatch({ type: `${DBI_TOPCHARTS}/setMetricValueListObj`, payload: { metricListValue: [] } });
      dispatch({ type: `${DBI_TOPCHARTS}/setMetricValueRangeTime`, payload: {} });
    },
    [],
  );

  return (
    <Content className="pc-console-topcharts__inner">
      <Content.Body full className="pc-console-topcharts__inner-body">
        <>
          <Card className="dbi-mobileGames-card-filter dbi-mobileGames-publisher">
            <Card.Body>
              {/* 筛选器 */}
              <CommonFilter
                ref={commonFilterRef}
                timeFilterValues={{
                  type: fetchParams.date_type,
                  value: [fetchParams.start_date, fetchParams.end_date],
                }}
                filterConfirm={(...params: any) => {
                  handleFilterConfirm(...params);
                  // updateFilterDatas(...params);
                }}
                filterValue={filterValue}
                setFilterValue={setFilterValue}
                filterCfg={{ ...filterCfg, enableSticky: true }}
                defaultInputList={filterConfigCur?.defaultInputList}
                // isBasicLoading={filterLoading}
                regionOptions={regionOptions}
                getRadioOptionsTips={getRadioOptionsTips}
                rangeTimeComponentDefault={rangeTimeComponentDefaultForReset}
                onToggleMoreFilter={onToggleMoreFilter}
                extendPageId={pageId}
              />
            </Card.Body>
          </Card>
          <Card className="dbi-mobileGames-card-context dbi-pcconsole-card-title dbi-pcconsole-card-title-metrics">
            <Card.Body
              title={
                <div style={{ display: 'flex' }}>
                  <span style={{ marginRight: 10 }}>{formatMessage({ id: 'dbi_label_metrics' })}</span>
                  <ArrowdownText
                    isNew={true}
                    sortedData={sortByName}
                    order={fetchParams?.order}
                    sortByKey={sortByKey}
                    dataSourcesColumns={dataSourcesColumns}
                  />
                  <span className="dib-sourcetips-explanation-divide"></span>
                  <SourceExplanation handleClickSourceState={handleClickSourceTips} openSource={openSource} />
                </div>
              }
              operation={
                tableLoading ? null : <ChartIconType chartType={chartType} handleChartType={handleChartMetricType} />
              }
            >
              {openSource && (
                <SummaryCard
                  isSourceTips={true}
                  openSource={openSource}
                  summarySourceKeyList={summarySourceKeyList}
                  summarySourceList={summarySourceList}
                />
              )}
              <MetricsTableVisualis
                isVisualisLoading={isVisualisLoading || trendLoading}
                visualLoadingHeight={visualLoadingHeight}
                orderMetric={fetchParams?.order_metric}
                fetchParams={fetchParams}
                topChartsType={entityType + pageId}
                imageType={entityType}
                entityType={entityType}
                lineData={lineData}
                barOrPieData={barOrPieData}
                chartType={chartType}
                metric={metric}
                setMetric={setMetric}
                sortByName={sortByName}
                sortByKey={sortByKey}
                defaultMetric={defaultMetricList}
                dateType={fetchParams?.date_type}
                startDate={fetchParams?.start_date}
                endDate={fetchParams?.end_date}
                pageIdToLine={`${pageId}ToLine`}
                pageId={pageId}
                isNodata={isNodata}
                handleChartMetricType={handleChartMetricType}
                formatMessage={formatMessage}
                noSuitableMsg={noSuitableMsg}
                metricSegVal={metricSegVal}
                setMetricSegVal={setMetricSegVal}
                setNoSuitableMsg={setNoSuitableMsg}
                dataSourcesColumns={dataSourcesColumns}
                gameHightList={gameHightList}
                isStudio={isStudio}
                handleChangeSegement={handleChangeSegement}
                useMarketFilterApiKey={'NOT_REQUIRED'} // 柱状图不需要再调用国家接口
              />
            </Card.Body>
          </Card>

          <Justify
            className="dbi-pcGame-jf pc-metricstable-jf dbi-card-justify"
            left={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CascaderMetricSelect
                  locale={locale}
                  options={metricSelectorOptions}
                  value={metricSelectorValues}
                  loading={tableLoading}
                  onConfirm={handleMetricSelectorChange}
                  shortcutOptions={STEAM_METRIC_SHORTCUT_OPTIONS}
                  className="dbi-combine-metrics-table-selector"
                />
                <ChangedMetricSelect
                  placeholder="dbi_surge_metric_placeholder"
                  pageLogKey={pageLogKey}
                  listHeight={180}
                  options={surgeMetricOptions}
                  value={surgeMetric}
                  onChange={handleSurgeMetricChange}
                />
                <TipContext AWidth={500} tipText={formatMessage({ id: 'dbi_surge_metric_tooltip_combine' })} />
              </div>
            }
            right={
              <>
                {hasSearch && (
                  <SearchRecent
                    searchType={`${entityType}`}
                    // 传入搜索的filter_ids要为[],不然后端会返回filter_ids里的游戏列表
                    fetchParams={{ ...fetchParams, page: 1, filter_ids: [] }}
                    handleClear={handleClearSearch}
                    getTableResultList={getTableSearchList}
                    searchListApi={fetchCommonTopChartsList}
                    pageLogInfo={pageLogInfo}
                    initSearchInput={!(fetchParams?.unified_ids?.length > 0)}
                    transTableDataForSearch={transTableDataForSearch}
                    useSearchRecentFun={seachRecordListPlus}
                  />
                )}
                {/** databrain页下载不提示 */}
                <ExportTable
                  downloadLogConfig={dbiTopChartsBtnLogMes?.[`${entityType}_${pageId}_TopChartsMetricsTableDownload`]}
                  downloadBtnLogConfig={
                    dbiTopChartsBtnLogMes?.[`${entityType}_${pageId}_TopChartsMetricsTableDownloadBtn`]
                  }
                  downloadModalSize={downloadModalSize}
                  entityType={entityType}
                  pageId={pageId}
                  businessType={businessType}
                  isDisableDownload={tableLoading}
                  total={tableTotal}
                  tableParams={handleDownloadParams(fetchParams)}
                  isNeedCheckedLines={true}
                  defaultCheckedLines={operatedGame}
                  isGameTopCharts={true}
                  hasBubbleCloseIcon={firstDownLoadBubleShow}
                  texts={downloadFormModelTexts}
                  newStyleFileName={(() => {
                    const base = `Top Charts_PC&Console Games`;
                    if (!selectedHotTagOption) return base;
                    const hotTagName = locale === 'zh-CN'
                      ? (selectedHotTagOption.name_cn || selectedHotTagOption.name || '')
                      : (selectedHotTagOption.name_en || selectedHotTagOption.name || '');
                    return hotTagName ? `Hot Tags_${hotTagName}_${base}` : base;
                  })()}
                  onBubbleClose={() => {
                    setFirstDownLoadBubleShow?.(false);
                    /** 下载首次提示关闭打点 ,与Activeuser页面的共用*/
                    buriedBtnPoint(dbiBtnLogMes.topchartMobileGameActiveUserDownLoadTip);
                  }}
                  isStudio={isStudio}
                  metricSelectorOptions={metricSelectorOptions}
                  useWebDownload={true}
                  downloadKey={downloadKey}
                />
              </>
            }
          />
          <div
            id="metrics-table-container"
            className={classnames('dbi-table', {
              'dbi-metrics-table-container-studio': isStudio,
            })}
          >
            <CardSlot className="dbi-metrics-table-container">
              {/* 表格列需要与合并榜静态列策略保持一致 */}
              <TableContent
                records={tableData}
                loading={tableLoading}
                tableTotal={tableTotal}
                tableSelection={tableSelection}
                tableSelectionAll={defaultSelectionGames}
                pageSortAttr={{
                  tablePageIndex: fetchParams?.page,
                  tablePageSize: fetchParams?.page_size,
                  currentSortValue: fetchParams?.order,
                  // 用于高亮排序
                  currentSortMetric: fetchParams?.order_device
                    ? `${fetchParams?.order_metric}_${fetchParams?.order_device}`
                    : fetchParams?.order_metric,
                  currentOrderSource: getClientDataSourceOfCombineMetricsTable(
                    fetchParams?.order_source,
                    fetchParams?.order_metric,
                    entityType,
                  ),
                  currentRatioType: fetchParams?.ratio_type,
                  currentOrderDevice: fetchParams?.order_device,
                }}
                onTableSortChage={onTableSortChage}
                onTablePagingChange={onTablePagingChange}
                onTableCheckGame={onTableCheckGame}
                selectDataSources={fetchParams?.data_sources}
                pageId={pageId}
                dateType={fetchParams?.date_type}
                startDate={fetchParams?.start_date}
                endDate={fetchParams?.end_date}
                genreSource={fetchParams?.genre_source ?? 'annie'}
                genreOptionsMap={formatedGenreOptionsMap}
                entityType={entityType}
                dataSourcesColumns={resolvedDataSourcesColumns}
                deviceSortByList={deviceSortByList}
                gameHightList={gameHightList}
                checkboxDisableTip={checkboxDisableTip}
                disableChckekList={gameHightList}
                onTagClick={handleSteamCellTagClick}
                onMetricExplanationClick={(key, payload) => {
                  handleMetricExplanationTipsClick(key, payload, {
                    filterValue,
                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                    onClickSetRegionUSOnly: handleFilterConfirm,
                  });
                }}
                jumpQuery={jumpQuery}
                gameInfoJumpQuery={detailJumpQuery}
              />
            </CardSlot>
          </div>
          {/* Competitor新手引导 */}
          <GuideCompetitor />
          {/* PC&Console 宽表Metric修改后筛选项变动提示 */}
          <FilterTipModal
            visible={filterTipModalVisible}
            onCancel={handleFilterTipModalCancel}
            onConfirm={handleFilterTipModalConfirm}
          />
        </>
      </Content.Body>
    </Content>
  );
};

export default PCConsoleTopCharts;
